import { captionFor, buyCaptionFor } from '@utils/alt/listAlt'

export default function offerSchemaName (buy, offer) {
    return buy
        ? buyCaptionFor(offer)
        : captionFor(offer)
}